import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router);

let tmpRoutes = [];

//================================== 登录
(function () {
  tmpRoutes.push.apply(tmpRoutes, [
    {
      name: 'Login',
      path: '/login',
      component: () => import('@/views/login/Login'),
      meta: {
        title: '登录',
        requireLogin: false
      }
    },
    {
      name: 'Reg',
      path: '/reg',
      component: () => import('@/views/login/Reg'),
      meta: {
        title: '注册',
        requireLogin: false
      }
    },
    {
      path: '/sso',
      component: () => import('@/views/login/Sso'),
      meta: {
        title: 'SSO',
      }
    },
  ]);
})();


//================================== 服务
(function () {
  tmpRoutes.push.apply(tmpRoutes, [

    /** 服务首页 **/
    {
      path: '/',//service
      name: 'Index',
      component: () => import('@/views/index/Index'),
      meta: {
        title: '首页',
        requireLogin: false,
        keepAlive: true
      }
    },
    {
      name: 'SearchList',
      path: '/SearchList',
      component: () => import('@/views/index/SearchList'),
      meta: {
        title: '搜索',
        requireLogin: false,
        keepAlive: true
      }
    },
    {
      name: 'NewsList',
      path: '/news',
      component: () => import('@/views/index/NewsList'),
      meta: {
        title: '新闻资讯',
        requireLogin: false,
        keepAlive: true
      }
    },
    {
      name: 'SigninDaily',
      path: '/SigninDaily',
      component: () => import('@/views/index/SigninDaily'),
      meta: {
        title: '每日签到',
        requireLogin: false,
        keepAlive: true
      }
    },
    {
      name: 'UserPoint',
      path: '/UserPoint',
      component: () => import('@/views/index/UserPoint'),
      meta: {
        title: '我的积分',
        requireLogin: false,
        keepAlive: true
      }
    },
    {
      name: 'PointRule',
      path: '/PointRule',
      component: () => import('@/views/index/PointRule'),
      meta: {
        title: '积分规则',
        requireLogin: false,
        keepAlive: true
      }
    },
    {
      name: 'PreviewSigninDaily',
      path: '/PreviewSigninDaily',
      component: () => import('@/views/index/PreviewSigninDaily'),
      meta: {
        title: '每日签到预览',
        requireLogin: false
      }
    },
    /** 门店列表 **/
    // {
    //   path: '/storelist',
    //   name: 'StoreList',
    //   component: () => import('@/views/service/StoreList'),
    //   meta: {
    //     title: '门店列表',
    //     requireLogin: false
    //   }
    // }
  ]);
})();


//================================== 兜底
(function () {
  tmpRoutes.push.apply(tmpRoutes, [
    {
      path: '*',
      redirect: '/',
    },
  ]);
})();

export default new Router({
  //mode: 'history',
  //base: '/',    
  //base: '/build/',
  routes: tmpRoutes,
})



// WEBPACK FOOTER //
// ./src/router/index.js